import {
  Box,
  Button,
  Modal,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import React, { FC, useState } from "react";
import { IMessage } from "../../../models/user/InsureAssist/InsureAssist";
import { useTranslation } from "react-i18next";

interface IProps {
  openFeedbackPopup: boolean;
  setOpenFeedbackPopup: (value: boolean) => void;
  feedbackDescription: string;
  handleFeedbackSubmit: (message: IMessage) => void;
  setFeedbackDescription: (value: string) => void;
  currentMsg: IMessage;
}

const InsureAssistFeedbackForm: FC<IProps> = ({
  openFeedbackPopup,
  setOpenFeedbackPopup,
  feedbackDescription,
  handleFeedbackSubmit,
  setFeedbackDescription,
  currentMsg,
}) => {
  const [reasons, setReasons] = useState<string[]>([]);

  const handleCheckboxChange = (reason: string) => {
    setReasons((prev) =>
      prev.includes(reason)
        ? prev.filter((r) => r !== reason)
        : [...prev, reason]
    );
  };

  const { t } = useTranslation();
  return (
    <Modal open={openFeedbackPopup} onClose={() => setOpenFeedbackPopup(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Typography variant="subtitle1">
          {t("Why did you choose this rating?")}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={reasons.includes("Not accurate")}
                onChange={() => handleCheckboxChange("Not accurate")}
              />
            }
            label={t("Not accurate")}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={reasons.includes("Not useful or incomplete")}
                onChange={() =>
                  handleCheckboxChange("Not useful or incomplete")
                }
              />
            }
            label={t("Not useful or incomplete")}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={reasons.includes("Something else")}
                onChange={() => handleCheckboxChange("Something else")}
              />
            }
            label={t("Something else")}
          />
        </Box>
        <TextField
          multiline
          rows={4}
          value={feedbackDescription}
          onChange={(e) => setFeedbackDescription(e.target.value)}
          placeholder={t("Enter your feedback")}
          variant="outlined"
          fullWidth
          sx={{
            borderRadius: 1,
            bgcolor: "background.default",
          }}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
          <Button
            onClick={() => setOpenFeedbackPopup(false)}
            variant="outlined"
            color="secondary"
          >
            {t("Cancel")}
          </Button>
          <Button
            onClick={() => handleFeedbackSubmit(currentMsg)}
            variant="contained"
            color="primary"
          >
            {t("Submit")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default InsureAssistFeedbackForm;
